import { http } from 'vue'
let r1 = false
let r2 = false
let resource = 'skus'
export default {
  loadSkus (context, params = {}) {
    return http.get(resource + '?product_id=' + params.productId + '&company_id=' + params.companyId, {
      before (request) {
        if (r1) r1.abort()
        r1 = request
      }
    })
  },
  loadSku (context, params = {}) {
    let onlyAvailableIdentifiers = (params.onlyAvailableIdentifiers) ? '&only_available_identifiers=1' : ''
    return http.get(resource + '/' + params.skuId + '?company_id=' + params.companyId + onlyAvailableIdentifiers, {
      before (request) {
        if (r2) r2.abort()
        r2 = request
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/skus/actions.js